import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-faq-question',
    templateUrl: './faq-question.component.html',
    styleUrl: './faq-question.component.scss',
    standalone: false
})
export class FaqQuestionComponent {
  @Input() expand: boolean = false;
  @Input() question: string;
  @Output() expandQuestion = new EventEmitter<boolean>()
  @Input() content: string;

  show() {
    this.expand = !this.expand;
    this.expandQuestion.emit(this.expand); 
  }
}
